import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Flex,
  Box,
  Button,
  useColorModeValue,
  IconButton,
  Tooltip,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import CreatorActivityDataTable from './components/CreatorActivityDataTable';
import { MdEdit, MdDelete } from 'react-icons/md';
import Popup from 'components/alerts/Popup';
import OnToast from 'components/alerts/toast';
import {
  getCreatorName,
  CreatoractivityStatus,
} from 'utils/creatorActivity/CreatorActivity';
import { getPlanName } from 'utils/plan/plan';
import {
  getEndDateById,
  getValidityPeriod,
} from 'utils/planvalidity/planvalidity';
import {
  MdGroupAdd,
  MdDone,
  MdClose,
  MdVideogameAsset,
  MdAdd,
} from 'react-icons/md';
import { MdOutlineAutorenew } from 'react-icons/md';
import { HashLoader } from 'react-spinners';

import { Switch } from '@chakra-ui/react';
interface CreatorActivityData {
  id: number;
  name: string;
  createdUserId: number | null;
  company: number;
  // status: string;
  CreatorEmail: any;
  companyNamess: string;
  CreatorName: string;
  Downloads: any;
  nooflearners: number;
  noofdownloads: number;
  noofgamespublished: number;
  noofgameslaunched: number;
  noofgames: number;
  timeSpent: any;
  LastActiveDate: string;
}

interface OptionType {
  value: string;
  label: string;
}

interface RowObj {
  id: number;
  sNo: number;
  // companyName: string;
  // CreatorName: string;
  CreatorEmail: any;
  companyNamess: string;
  CreatorName: string;
  createdUserId: number;
  company: number;
  nooflearners: number;
  noofdownloads: number;
  noofgamespublished: number;
  Downloads: any;
  noofgameslaunched: number;
  noofgames: number;
  timeSpent: any;
  // timeSpent: string | null;
  LastActiveDate: string;

  plan: string;
  validity: string;
  // action: any;
}
interface CreatorActivityDataTableProps {
  data: RowObj[];
}
interface planType {
  plPlanName: string;
  plId: string;
  // other properties if any
}

const CreatorActivityCreation: React.FC = () => {
  const [apiData, setApiData] = useState<CreatorActivityData[]>([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [companyNames, setCompany] = useState([]);
  const [creatorNames, setCreator] = useState([]);

  const [isConfirm, setIsConfirm] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const [deleteId, setDeleteId] = useState<number>();
  const navigate = useNavigate();
  const [loadingdata, setLoadingdata] = useState(false);

  const fetchData = async () => {
    setLoadingdata(true);

    try {
      const result = await getCreatorName();

      if (result?.status !== 'Success') {
        console.log('getCreatorName Error:', result?.message);
        setApiData([]);
        return;
      }

      setApiData(result?.data);
    } catch (error) {
      console.log('Error during fetchData:', error);
      setApiData([]);
    } finally {
      setLoadingdata(false);
    }
  };

  const handleDelete = async (ctId: number) => {
    setDeleteId(ctId);
    setIsOpen(true);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleNavigate = (ctId?: number) => {
    if (ctId) {
      navigate(`/admin/superadmin/creator/creation/${ctId}`);
    } else {
      navigate('creation');
    }
  };

  const transformData = (
    apiData:
      | CreatorActivityData[]
      | { count: number; rows: CreatorActivityData[] },
  ): RowObj[] => {
    // Extract the array from 'rows' if apiData is an object
    const dataArray = Array.isArray(apiData) ? apiData : apiData.rows;

    // Check if dataArray is an array
    if (!Array.isArray(dataArray)) {
      return [];
    }
    // console.log("data.companyNames",data?.companyNames)
    return dataArray.map((data, index) => ({
      id: data.id,
      sNo: index + 1,
      // company:data.company,
      CreatorName: data.name,
      CreatorEmail: data.CreatorEmail,
      companyNamess: data.companyNamess,
      createdUserId: data.createdUserId !== null ? data.createdUserId : 0,
      company: companyNames.find((item) => item.value === data.company)?.label,
      nooflearners: data.nooflearners,
      noofdownloads: data.noofdownloads,
      noofgamespublished: data.noofgamespublished,
      noofgameslaunched: data.noofgameslaunched,
      noofgames: data.noofgames,
      Downloads: data.Downloads,
      timeSpent: data.timeSpent,
      LastActiveDate: data.LastActiveDate,

      plan: '', // You need to define how you get the plan value
      validity: '', // You need to define how you get the validity value
    }));
  };

  const transformedData: RowObj[] = transformData(apiData);

  return (
    <>
      {/* Leo*/}
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Box mb={{ base: '100px', md: '100px', xl: '100px' }}></Box>

      <CreatorActivityDataTable
        data={transformedData}
        setApiData={setApiData}
        setCompany={setCompany}
        setCreator={setCreator}
      />

      {isOpen ? (
        <Popup
          setDeleteId={setDeleteId}
          setIsConfirm={setIsConfirm}
          setIsOpen={setIsOpen}
          msg={''}
          setmsg={''}
        />
      ) : null}
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
};

export default CreatorActivityCreation;
